import { render, staticRenderFns } from "./BankTable.vue?vue&type=template&id=236316e7&"
import script from "./BankTable.vue?vue&type=script&lang=js&"
export * from "./BankTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports